import { Badge } from "reactstrap";
import i18n from "../../../i18n";
import { printSlug } from "../../../utils/helpers/text";

const LEAVE_TYPE_LABELS = {
  'sick-leave': 'hr.sickLeave',
  'authorized-leave': 'hr.authorizedLeave',
  'unauthorized-leave': 'hr.unauthorizedLeave',
  'annual-leave': 'hr.annualLeave',
  'long-term-sick-leave': 'hr.longTermSickLeave',
  'maternity-leave': 'hr.maternityLeave',
  'paternity-leave': 'hr.paternityLeave',
  'marriage-leave': 'hr.marriageLeave',
  'bereavement-leave': 'hr.bereavementLeave',
  'unpaid-leave': 'hr.unpaidLeave',
  'training-study-leave': 'hr.trainingStudyLeave'
};

const EMPLOYMENT_STATUS_COLORS = {
  active: 'success',
  probation: 'info',
  suspended: 'warning',
  terminated: 'secondary'
};

export function printEmploymentStatus(status) {
  const resolved = status || 'active';
  return (
    <Badge color={EMPLOYMENT_STATUS_COLORS[resolved] || 'dark'}>
      {i18n.t(`hr.employmentStatus.${resolved}`)}
    </Badge>
  );
}

export function printLeaveStatus(status) {
  switch (status) {
    case 'pending':
      return <Badge color="warning">{i18n.t('common.pending')}</Badge>;
    case 'approved':
      return <Badge color="success">{i18n.t('common.approved')}</Badge>;
    case 'rejected':
      return <Badge color="danger">{i18n.t('common.rejected')}</Badge>;
    case 'cancelled':
      return <Badge color="secondary">{i18n.t('common.canceled')}</Badge>;
    default:
      return <Badge color="dark">{i18n.t('common.unknownStatus')}</Badge>;
  }
}

// leave_type is stored as a comma separated list of slugs
export function leaveTypesToArray(leaveType) {
  if (!leaveType) return [];
  if (Array.isArray(leaveType)) return leaveType;
  return leaveType.split(',').map(type => type.trim()).filter(type => type);
}

export function printLeaveType(leaveType) {
  return leaveTypesToArray(leaveType)
    .map(type => LEAVE_TYPE_LABELS[type] ? i18n.t(LEAVE_TYPE_LABELS[type]) : printSlug(type))
    .join(', ');
}
